import { useStyles } from './styles'
import { Skeleton } from '@mui/material'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'

export const CasesListSkeleton = () => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.boxPage

  const lastSkeletons = [{ height: 100 }, { height: 100 }]

  return (
    <div className={classes.root}>
      <h1 className={classes.h1}>{texts.heading.cases}</h1>
      <Skeleton
        variant="rounded"
        width={'100%'}
        height={68}
        sx={{ borderRadius: '12px', minHeight: '68px' }}
      />
      <Skeleton
        variant="rounded"
        width={'100%'}
        height={120}
        sx={{ borderRadius: '12px', minHeight: '120px' }}
      />
      <Skeleton
        variant="rounded"
        width={'100%'}
        height={100}
        sx={{ borderRadius: '12px', minHeight: '100px' }}
      />
      <h2 className={classes.caseListHeading}>{texts.availableCases}</h2>

      {lastSkeletons.map((skeleton, index) => (
        <Skeleton
          key={index}
          variant="rounded"
          width={'100%'}
          height={skeleton.height}
          sx={{ borderRadius: '12px', minHeight: `${skeleton.height}px` }}
        />
      ))}
    </div>
  )
}
